import { LicenseInfo } from '@mui/x-license-pro';

export function initReactMUI() {
  LicenseInfo.setLicenseKey('6ee025548d22ee86b0867955f09f3f3fTz03NjU3NixFPTE3Mjg4MTY0NDYwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
}
